export const actionMap = {}

export const defaultState = {
    message: undefined,
    status: undefined
}

export default (reduxState = defaultState, action) => {
    if (action !== undefined && actionMap[action.type]) {
        return actionMap[action.type](reduxState, action)
    }
    return reduxState
}



// WEBPACK FOOTER //
// ./src/shared/errorHandler/reducer/index.js